import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Nombre de descarga: {número}_{e-NCF} (ej. GA-000009_E470000000004)
export const docFileName = (d) => (d?.ncf ? `${d.number}_${d.ncf}` : d?.number || d?.id || "documento");
